import { render } from "./PhraseLibraryView.vue?vue&type=template&id=43f64836&scoped=true"
import script from "./PhraseLibraryView.vue?vue&type=script&lang=js"
export * from "./PhraseLibraryView.vue?vue&type=script&lang=js"

import "./PhraseLibraryView.vue?vue&type=style&index=0&id=43f64836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f64836"]])

export default __exports__